module.exports = __webpack_public_path__ + "static/media/check-active.1b3e95e7.png";